module.exports = __webpack_public_path__ + "static/logo fesaem-1cdc74b7c1663a5d67faec245d2de23c.png";